import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="coupon-notice-modal"
// 表示した時点でCookieを記録し、同じグラントにつき端末ごとに1回だけ表示する
export default class extends Controller {
  static values = {
    cookieKey: String
  }

  connect() {
    if (this.cookieExists()) {
      this.element.remove()
      return
    }

    this.markAsShown()
    this.element.removeAttribute("hidden")
  }

  close() {
    this.element.remove()
  }

  markAsShown() {
    const expires = new Date()
    expires.setDate(expires.getDate() + 180)

    document.cookie = `${this.cookieKeyValue}=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
  }

  cookieExists() {
    return document.cookie
      .split("; ")
      .some((item) => item.startsWith(`${this.cookieKeyValue}=`))
  }
}
